module.exports = __webpack_public_path__ + "media/admin/cs_evaluation_request_004_lg-d0e4fda5.png";